export const SIGN_IN = 'SIGN_IN'
export const SIGN_OUT = 'SIGN_OUT'
export const RECOVERY = 'RECOVERY'
export const ME = 'ME'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const TWITTER_REDIRECT = 'TWITTER_REDIRECT'
export const SIGN_UP = 'SIGN_UP'
export const RESEND_MESSAGE = 'RESEND_MESSAGE'
export const SIGN_UP_EMAIL_CONFIRM = 'SIGN_UP_EMAIL_CONFIRM'
